import { CTA } from "@/features/landing/CTA";
import { Features } from "@/features/landing/Features";
import { Hero } from "@/features/landing/Hero";
import { HowItWorks } from "@/features/landing/HowItWorks";

export function LandingPage() {
  return (
    <>
      <Hero />
      <HowItWorks />
      <Features />
      <CTA />
    </>
  );
}
